import { DEPT_NORMAL, DEPT_MINISTER, DEPT_LEADER, BUREAU_MINISTER, BUREAU_MANAGE, PARTY_GROUP, ASSESS_MINITOR, ROOT_ACCOUNT } from "../utils/utilData";
import { events, personalTaskTable, employeeScoreTable, deptTaskTable, deptScoreTable, commonEvaEmployeeTable, commonEvaDeptTable, weekSummaryTable } from "../data/Index";
import NightingaleChart from "@/components/NightingaleChart.vue";
import { post } from "../utils/request";
import { getShortEntrance } from "../data/Index";
import router from "../router";
import { ElMessage } from "element-plus";
import { seasonTransfer } from "../utils/utilApi";


export default {
  data() {
    return {
      showable: {
        summary: false,
      },
      year: String(new Date().getFullYear()),
      season: Math.floor((new Date().getMonth()) / 3) + 1,
      userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
      roleId: JSON.parse(sessionStorage.getItem("roleList"))[0].roleId,
      departmentId: JSON.parse(sessionStorage.getItem("departmentInfo")).departmentId,
      personalTaskTable: [], // 个人工作任务完成情况表
      employeeScoreTable: [], // 考评得分情况
      deptTaskTable: [], // 科室整体工作任务完成情况表
      deptScoreTable: [], // 科室整体考评得分情况
      personalTaskList: [], // 个人工作任务完成情况数据
      employeeScoreList: [], // 考评得分数据
      deptTaskList: [], // 科室整体工作任务数据
      deptScoreList: [], // 科室整体考评得分数据
      shortEntranceList: [], // 快捷入口
      role: parseInt(JSON.parse(sessionStorage.getItem("roleList"))[0].roleId), // 当前用户角色
      eventsList: events, // 待办事项
      chartData: [], // 个人考评得分
      commonEvaEmployeeTable: [], // 科室共性指标考评进度(哪些人评好了哪些人没好)
      commonEvaEmployeeList: [],
      commonEvaDeptTable: [],
      commonEvaDeptList: [],
      sysParam: {
        company: "",
        numberQQ: "",
        numberPhone: ""
      },
      weekSummaryTable: [],
      weekSummaryList: [{ userId: 111, season1: 1, season2: 2, season3: 0 }],
      weekSummaryDetailList: [],
    };
  },
  name: "Index",
  components: { NightingaleChart },
  methods: {
    formatter(row, column) {
      if (column.property == 'commonEvaUncomp') {
        return parseInt(row.totalNum) - parseInt(row.commonEvaComp);
      } else if (column.property == 'proportion') {
        return (parseInt(row.commonEvaComp) / parseInt(row.totalNum) * 100).toFixed(1);
      } else {
        return row[column.property];
      }
    },
    formatter2(row, column) {
      if (column.property == 'evaluate') {
        return row.evaluate == true ? "已考核" : "未考核";
      } else {
        return row[column.property];
      }
    },
    shortLink(dir) {
      router.push('/' + dir);
    },
    // 待办事项提醒
    getEvents() {
      this.eventList = [];
      switch (this.role) {
        // 科员
        case DEPT_NORMAL: {
          this.eventList.push()
          break;
        }
        // 科长
        case DEPT_MINISTER: {
          break;
        }
        // 副局长、分管领导
        case DEPT_LEADER: {
          break;
        }
      }
    },
    /**
     * @description 获取个人的考核成绩(此功能仅限科员和科长使用)
     * @function POST /eva/result/search/personal
     * 
     * @param {int} year 年度
     * @param {String} season 季度
     * @param {int} userId 用户Id
     * @return {Object} 返回数据名称data，其中包括totalScore综合得分和detailScore[]得分细则，detailScore[]包括commonScore共性指标得分, taskScore个性指标得分, attendanceScore考勤得分, specialScore党委得分这四项。这四项中每一项为{value, name}形式
     */
    getPersonalScore() {
      let data = {
        year: this.year,
        season: this.season,
        userId: this.userId,
      }
      post("/eva/result/search/personal", JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          let data = JSON.parse(res.data.data);
          this.chartData = [
            { name: "共性指标", value: data.detailScore.commonScore },
            { name: "个性指标", value: data.detailScore.taskScore },
            { name: "考勤得分", value: data.detailScore.attendanceScore },
            { name: "党委评分", value: data.detailScore.specialScore },
          ]

        }
      });
    },
    /**
     * @description 查询用户的个性指标完成情况。
     * @function POST /task/detail/personal
     * 
     * @param {int} type 1为仅查询userId的个性指标完成情况。2为查询科室所有成员的个性指标完成情况，包括科室长自己
     * @param {int} userId 用户ID
     * @param {int} departmentId 部门ID，type为2时用到
     * @param {int} year 年度
     * @param {int} season 季度
     * 
     * @returns 返回集合或数组的属性名为data。其中每一项包括userId用户Id，name用户姓名，taskNum任务总数，accomplishNum任务完成数，unaccomplishNum任务未完成数，accomplishRate完成率(%)
     */
    getPersonalTask() {
      let data = {
        type: this.roleId == DEPT_NORMAL ? 1 : 2,
        userId: this.userId,
        departmentId: this.departmentId,
        year: this.year,
        season: this.season,
      };
      post("/task/detail/personal", JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.personalTaskList = JSON.parse(res.data.data);
        }
      });
    },
    /**
     * @description 查询科室成员的考评结果，包括科长自己。
     * @function POST /evaResult/search/employee
     * 
     * @param {int} year 年度
     * @param {int} season 季度
     * @param {int} departmentId 部门ID
     * @param {int} userId 用户ID
     * 
     * @returns 返回集合或数组的属性名为data。其中每一项包括userId用户Id，name用户姓名，totalScore综合得分，rate考评等次
     */
    getEmployeeScore() {
      let data = {
        year: this.year,
        season: this.season,
        userId: this.userId,
        departmentId: this.departmentId,
      };
      post("/evaResult/search/employee", JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.employeeScoreList = JSON.parse(res.data.data);
        }
      });
    },
    /**
     * @description 查询科室整体的个性任务完成情况（分管局长只能看到自己管理的科室）
     * @function POST /task/detail/dept
     * 
     * @param {int} type 1表示当前用户为分管局长，只查询部分科室；2表示查询单位所有科室
     * @param {int} userId 用户ID
     * @param {int} departmentId 部门ID
     * @param {int} year 年度
     * @param {int} season 季度
     * 
     * @returns 返回集合或数组的属性名为data。其中每一项包括departmentId科室Id，departmentName科室名，taskNum任务总数，accomplishNum任务完成数，unaccomplishNum任务未完成数，accomplishRate完成率(%)
     */
    getDeptTask() {
      let data = {
        type: this.roleId == DEPT_LEADER ? 1 : 2,
        userId: this.userId,
        departmentId: this.departmentId,
        year: this.year,
        season: this.season,
      };
      post("/task/detail/dept", JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.deptTaskList = JSON.parse(res.data.data);
        }
      });
    },
    /**
     * @description 查询科室成员的考评结果，包括科长自己。
     * @function POST /evaResult/search/dept
     * 
     * @param {int} type 1表示当前用户为分管局长，只查询部分科室；2表示查询单位所有科室
     * @param {int} userId 用户ID
     * @param {int} departmentId 部门ID，type为2时用到
     * @param {int} year 年度
     * @param {int} season 季度
     * 
     * @returns 返回集合或数组的属性名为data。其中每一项包括departmentId科室Id，departmentName科室名，totalScore综合得分，rate考评等次
     */
    getDeptScore() {
      let data = {
        type: this.roleId == DEPT_LEADER ? 1 : 2,
        departmentId: this.departmentId,
        userId: this.userId,
        year: this.year,
        season: this.season,
      }
      post("/evaResult/search/dept", JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.deptScoreList = JSON.parse(res.data.data);
        }
      });
    },
    /**
    * @description 查询科室成员的共性指标考核进度（哪些人评完了，哪些人没完成）
    * @function POST evaluate/status/search/employee
    * 
    * @param {int} userId 用户ID
    * @param {int} departmentId 部门ID
    * @param {int} year 年度
    * @param {int} season 季度
    * 
    * @returns 返回集合或数组的属性名为data。其中每一项包括userId用户ID, username用户姓名, evaluate是否评价完成
    */
    getEmpCommonEvaStatus() {
      let data = {
        year: this.year,
        season: this.season,
        userId: this.userId,
        departmentId: this.departmentId,
      };
      post("/evaluate/status/search/employee", JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.commonEvaEmployeeList = JSON.parse(res.data.data);
        }
      });
    },
    /**
    * @description 查询部门所有科室的共性指标考核进度（科室有多少人评完了多少人没完成）
    * @function POST evaluate/status/search/dept
    * 
    * @param {int} userId 用户ID
    * @param {int} departmentId 部门ID
    * @param {int} year 年度
    * @param {int} season 季度
    * 
    * @returns 返回集合或数组的属性名为data。其中每一项包括departmentId科室Id, departmentName科室名称, commonEvaComp科室完成人数, totalNum科室总人数
    */
    getDeptCommonEvaStatus() {
      let data = {
        year: this.year,
        season: this.season,
        userId: this.userId,
        departmentId: this.departmentId,
      };
      post("evaluate/status/search/dept", JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.commonEvaDeptList = JSON.parse(res.data.data);
        }
      });
    },
    // 查询系统信息
    searchSysParam() {
      post("/sysparam/search").then((res) => {
        if (res.code == 200) {
          let data = JSON.parse(res.data.data);
          this.sysParam.numberQQ = data.numberQQ;
          this.sysParam.numberPhone = data.numberPhone;
          this.sysParam.company = data.company;
        }
      });
    },
    // 保存系统参数信息
    saveSysParam() {
      post("/sysparam/save", JSON.stringify(this.sysParam)).then((res) => {
        if (res.code == 200) {
          ElMessage.success("保存成功", {
            duration: 3 * 1000,
          });
          return;
        }
      });
    },
    roleJudge(allowRoleArr) {
      for (let i = 0; i < allowRoleArr.length; i++) {
        if (allowRoleArr[i] == this.role) {
          return true;
        }
      }
      return false;
    },
    // 查询具体小结内容
    searchSummaryDetail(row, column, cell, event) {
      let season = column.property;
      // 非季度行或数据为0则不查询
      if (season.slice(0, -1) != "season" || parseInt(row[season]) == 0) {
        return;
      }
      let data = {
        userId: row.userId,
        season: seasonTransfer(season.slice(-1)),
        year: this.year,
      };

      post('/summary/search', JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.weekSummaryDetailList = JSON.parse(res.data.data);
          this.showable.summary = true;
        }
      });
    },
    /**
     * @description 查询所负责用户每个季度小结数量
     * @function POST /summary/search/dept
     * 
     * @param {int} type 1表示科长，2表示分管领导
     * @param {int} userId 用户ID
     * @param {int} departmentId 部门ID
     * @param {int} year 年度
     * 
     * @returns 返回集合或数组的属性名为data。其中每一项包括userId用户Id, userName用户姓名, departmentId科室Id, departmentName科室名称, season1第1季度小结数量, season2第2季度小结数量, season3第3季度小结数量, season4第4季度小结数量
     */
    searchSummaryList() {
      let data = {
        type: this.roleId == DEPT_LEADER ? 2 : 1,
        departmentId: this.departmentId,
        userId: this.userId,
        year: this.year,
      }
      post("/summary/search/dept", JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.weekSummaryList = JSON.parse(res.data.data);
        }
      });
    },
  },

  computed: {
    // 根据不同的角色计算返回不同的快捷入口
    entrance() {
      return [];
    },
    // 科员、科长、局级管理
    // 快捷入口
    shortEntrance() {
      let allowRoleArr = [DEPT_NORMAL, DEPT_MINISTER, BUREAU_MANAGE, DEPT_LEADER];
      // console.log(this.role, allowRoleArr);
      // for (let i = 0; i < allowRoleArr.length; i++) {
      //   if (allowRoleArr[i] == this.role) {
      //     return true;
      //   }
      // }
      // return false;
      return this.roleJudge(allowRoleArr);
    },
    // 科员、科长、局级管理
    // 考评待办事项
    evaEventsFlag() {
      // let allowRoleArr = [DEPT_NORMAL, DEPT_MINISTER, DEPT_LEADER];
      // console.log(this.role, allowRoleArr);
      // for (let i = 0; i < allowRoleArr.length; i++) {
      //   if (allowRoleArr[i] == this.role) {
      //     return true;
      //   }
      // }
      return false;
    },
    // 判断是否是科员或科长
    // 个人考评情况，各项得分
    personalScoreDetail() {
      let allowRoleArr = [DEPT_NORMAL, DEPT_MINISTER];
      // for (let i = 0; i < allowRoleArr.length; i++) {
      //   if (allowRoleArr[i] == this.role) {
      //     return true;
      //   }
      // }
      // return false;
      return this.roleJudge(allowRoleArr);
    },
    // 科长、科员
    // 个性指标完成情况
    personTaskMinitor() {
      let allowRoleArr = [DEPT_NORMAL, DEPT_MINISTER];
      // for (let i = 0; i < allowRoleArr.length; i++) {
      //   if (allowRoleArr[i] == this.role) {
      //     return true;
      //   }
      // }
      // return false;
      return this.roleJudge(allowRoleArr);
    },
    // 科长
    // 考核综合得分
    employeeScoreDetail() {
      let allowRoleArr = [DEPT_MINISTER];
      // for (let i = 0; i < allowRoleArr.length; i++) {
      //   if (allowRoleArr[i] == this.role) {
      //     return true;
      //   }
      // }
      // return false;
      return this.roleJudge(allowRoleArr);
    },
    // 分管领导、绩效、局长、局级管理、党组
    // 科室个性指标完成情况
    deptTaskMinitor() {
      let allowRoleArr = [DEPT_LEADER, ASSESS_MINITOR, BUREAU_MINISTER, BUREAU_MANAGE, PARTY_GROUP];
      // for (let i = 0; i < allowRoleArr.length; i++) {
      //   if (allowRoleArr[i] == this.role) {
      //     return true;
      //   }
      // }
      // return false;
      return this.roleJudge(allowRoleArr);
    },
    // 分管领导、绩效、局长、局级管理、党组
    // 科室综合均分
    deptScoreDetail() {
      let allowRoleArr = [DEPT_LEADER, ASSESS_MINITOR, BUREAU_MINISTER, BUREAU_MANAGE, PARTY_GROUP]
      // for (let i = 0; i < allowRoleArr.length; i++) {
      //   if (allowRoleArr[i] == this.role) {
      //     return true;
      //   }
      // }
      // return false;
      return this.roleJudge(allowRoleArr);
    },
    // 科室成员共性指标考核状况
    empCommonEvaStatus() {
      let allowRoleArr = [DEPT_MINISTER];
      // for (let i = 0; i < allowRoleArr.length; i++) {
      //   if (allowRoleArr[i] == this.role) {
      //     return true;
      //   }
      // }
      // return false;
      return this.roleJudge(allowRoleArr);
    },
    // 科室共性指标考核状况
    deptCommonEvaStatus() {
      let allowRoleArr = [BUREAU_MANAGE];
      // for (let i = 0; i < allowRoleArr.length; i++) {
      //   if (allowRoleArr[i] == this.role) {
      //     return true;
      //   }
      // }
      // return false;
      return this.roleJudge(allowRoleArr);
    },
    WeekSummaryStatus() {
      let allowRoleArr = [DEPT_LEADER, DEPT_MINISTER];
      // for (let i = 0; i < allowRoleArr.length; i++) {
      //   if (allowRoleArr[i] == this.role) {
      //     return true;
      //   }
      // }
      // return false;
      return this.roleJudge(allowRoleArr);
    },
    rootRole() {
      let allowRoleArr = [ROOT_ACCOUNT];
      // for (let i = 0; i < allowRoleArr.length; i++) {
      //   if (allowRoleArr[i] == this.role) {
      //     return true;
      //   }
      // }
      // return false;
      return this.roleJudge(allowRoleArr);
    }
  },
  created() {
    this.personalTaskTable = personalTaskTable;
    this.employeeScoreTable = employeeScoreTable;
    this.deptTaskTable = deptTaskTable;
    this.deptScoreTable = deptScoreTable;
    this.shortEntranceList = getShortEntrance(this.roleId);
    this.commonEvaEmployeeTable = commonEvaEmployeeTable;
    this.commonEvaDeptTable = commonEvaDeptTable;
    this.weekSummaryTable = weekSummaryTable;
    if (this.personalScoreDetail) {
      this.getPersonalScore();
    }
    if (this.personTaskMinitor) {
      this.getPersonalTask();
    }
    if (this.employeeScoreDetail) {
      this.getEmployeeScore();
    }
    if (this.deptTaskMinitor) {
      this.getDeptTask();
    }
    if (this.deptScoreDetail) {
      this.getDeptScore();
    }
    if (this.empCommonEvaStatus) {
      this.getEmpCommonEvaStatus();
    }
    if (this.deptCommonEvaStatus) {
      this.getDeptCommonEvaStatus();
    }
    if (this.WeekSummaryStatus) {
      this.searchSummaryList();
    }
    if (this.rootRole) {
      this.searchSysParam();
    }

  }
};